// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1hmsglyw{text-decoration-line:none}\n._4bfu1r31{text-decoration-color:currentColor}\n._ajmmnqa1{text-decoration-style:solid}", ""]);
// Exports
module.exports = exports;
